import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import citadelLogo from '../../images/citadel/logo.svg'
import { citadelTheme } from '../../themes/citadelTheme'

import BodyText, { Subheading, BoldSpan } from '../styles/Text'
import { CenteredFlexColumn } from '../styles/Containers'

const CenteredRow = styled(CenteredFlexColumn)`
  flex-direction: row;
  justify-content: center;
`

const LogoFlexColumn = styled(CenteredFlexColumn)`
  padding: 0 0 50px;
`

const Logo = styled.img`
  height: 35px;
`

const SmallSubheading = styled(Subheading)`
  font-size: 13px;
`

const PrimaryBodyText = styled(BodyText)`
  color: ${citadelTheme.colors.primary};
`

const PoweredBy = ({ type = 'horizontal' }) => (
  <>
    {type === 'horizontal' && (
      <CenteredRow width="100%">
        <Subheading>Powered By</Subheading>
        <Logo src={citadelLogo} aria-label="VivaCitadel" />
        <PrimaryBodyText>
          <BoldSpan>VIVA</BoldSpan>CITADEL
        </PrimaryBodyText>
      </CenteredRow>
    )}
    {type === 'vertical' && (
      <CenteredFlexColumn gap="10px">
        <Logo src={citadelLogo} aria-label="VivaCitadel" />
        <CenteredFlexColumn gap="5px">
          <SmallSubheading>Powered By</SmallSubheading>
          <PrimaryBodyText>
            <BoldSpan>VIVA</BoldSpan>CITADEL
          </PrimaryBodyText>
        </CenteredFlexColumn>
      </CenteredFlexColumn>
    )}
    {type === 'paddedLogo' && (
      <LogoFlexColumn gap="10px" padding="tall">
        <Logo src={citadelLogo} aria-label="VivaCitadel" />
      </LogoFlexColumn>
    )}
  </>
)

PoweredBy.propTypes = {
  type: PropTypes.oneOf(['horizontal', 'vertical', 'paddedLogo'])
}

export default PoweredBy
